export default __webpack_public_path__ + "static/media/goalbase_navicon.38282ef3.svg";